import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import LogoImg from '~/assets/icons/logo.webp';
import HeaderPublicActions from '~/components/organisms/header-public-actions/HeaderPublicActions';
import HeaderPublicTabs from '~/components/organisms/header-public-tabs/HeaderPublicTabs';
import MobileDrawer from '~/components/organisms/MobileDrawer/MobileDrawer';
import { PATH } from '~/constants/route-path';
import { getIsDesktop } from '~/store/reducers/app/selectors';

import { StyledHeader, StyledHeaderContent, StyledLogo, StyledLogoWrapper } from './styled';

export default function HeaderPublic() {
  const navigate = useNavigate();

  const isDesktop = useSelector(getIsDesktop);

  return (
    <StyledHeader>
      <div className="customContainer">
        <StyledHeaderContent>
          <StyledLogoWrapper onClick={() => navigate(PATH.UNAUTH.MAIN)}>
            <StyledLogo src={LogoImg} alt="logo" />
          </StyledLogoWrapper>
          {isDesktop && <HeaderPublicTabs />}
          {isDesktop ? <HeaderPublicActions /> : <MobileDrawer />}
        </StyledHeaderContent>
      </div>
    </StyledHeader>
  );
}
